<template>
  <div class="rm-relative">
    <div class="field has-addons">
      <p class="control is-expanded">
        <input
          type="text"
          class="input"
          placeholder="Search an area or locality"
          v-model="searchText"
          @keyup.enter="onSearchAddress"
        />
      </p>
      <p class="control">
        <button class="button" @click="loadCurrentLocation">
          <span class="icon">
            <font-awesome-icon icon="location-arrow" />
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button" @click="onSearchAddress">
          <span class="icon">
            <font-awesome-icon icon="search" />
          </span>
        </button>
      </p>
    </div>
    <div v-if="suggestions && suggestions.length > 0" class="panel rm-dropdown">
      <a
        v-for="suggestion in suggestions"
        :key="suggestion.place_id"
        href="#"
        @click.prevent="onSelectSuggestion(suggestion)"
        class="panel-block"
      >{{ suggestion.description }}</a>
    </div>
  </div>
</template>

<script>
import Util from '@/util'
import { mapState } from 'vuex'

export default {
  name: "AddressSelect",
  props: ['autoLocate', 'noAddressFetch', 'igmoreLastSearchAddress'],
  data() {
    return {
      searchText: null,
      suggestions: [],
      address: {
        addressLine: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        geolocation: null
      }
    }
  },

  created() {
    this.gmapInit()
  },

  activated() {
    if (this.autoLocate) {
      this.loadCurrentLocation();
    }
  },

  computed: {
    ...mapState('user', ['lastSearchedAddr']),
    addressComponents() {
      let out = [];
      [this.address.city, this.address.state, this.address.country, this.address.zip].forEach(field => {
        if (field) out.push(field);
      });
      return out.join(", ");
    },
    mapConfig () {
      return this.$store.getters['business/mapConfig']
    }
  },

  watch: {
    address: {
      handler: function() {
        const al = this.address.addressLine
        if (al && al.trim().length > 0 && this.address.geolocation) {
          this.$store.dispatch('user/updateLastSearchedAddr', this.address);
          this.$emit("addresschanged", this.address);
        }
      },
      deep: true
    }
  },

  methods: {
    resetAddress() {
      this.address = {
        addressLine: null,
        city: null,
        state: null,
        zip: null,
        country: null,
        geolocation: null
      }
    },

    loadCurrentLocation() {
      navigator.geolocation.getCurrentPosition(
        pos => {
          if (this.noAddressFetch) {
            if (this.igmoreLastSearchAddress) {
              this.address.geolocation = [pos.coords.longitude, pos.coords.latitude]
              this.$store.dispatch('user/updateCurrentLocation', this.address)
              this.$emit("addresschanged", this.address)
              return
            } else if (this.lastSearchedAddr) {
              this.address.geolocation = [pos.coords.longitude, pos.coords.latitude]
              if (this.lastSearchedAddr) {
                this.address.state = this.lastSearchedAddr.state
              }
              this.$store.dispatch('user/updateCurrentLocation', this.address)
              this.$emit("addresschanged", this.address)
              return
            }
          }
          this.getAddressByLocation(pos.coords);
        },
        () => {
          // error do nothing
        },
        { maximumAge: 3000, timeout: 30000, enableHighAccuracy: true }
      );
    },

    getAddressByLocation(coords) {
      if (!this.google) {
        this.gmapInit()
      }
      var geoCoder = new this.google.maps.Geocoder();
      geoCoder.geocode(
        {
          location: {
            lat: coords.latitude,
            lng: coords.longitude
          }
        },
        (results, status) => {
          if (status === this.google.maps.GeocoderStatus.OK) {
            Util.parseAddress(results, this.address)
            if (this.address.addressLine) {
              this.searchText = this.address.addressLine
            }
            this.address.geolocation = [coords.longitude, coords.latitude]
            this.$store.dispatch('user/updateCurrentLocation', this.address)
          }
        }
      )
    },

    onSearchAddress() {
      if (!this.searchText) {
        return
      }
      if (!this.google) {
        this.gmapInit()
      }
      const autoComplete = new this.google.maps.places.AutocompleteService();
      const rParams = {
        input: this.searchText
      };

      const { countryCode, maxDistance = 5, distanceUnit = "km", geolocation } =
        this.mapConfig || {};

      if (countryCode) {
        rParams.componentRestrictions = {
          country: this.mapConfig.countryCode
        };
      }

      let radius = maxDistance * 1000;
      if (distanceUnit === "mi") {
        radius = maxDistance * 1609.34;
      }

      if (geolocation) {
        const coords = this.mapConfig.geolocation;
        rParams.location = new this.google.maps.LatLng(coords[1], coords[0]);
        rParams.radius = radius;
      }

      autoComplete.getPlacePredictions(rParams, results => {
        this.suggestions = results;
      });
    },

    onSelectSuggestion(suggestion) {
      const geoCoder = new this.google.maps.Geocoder();

      this.suggestions = []
      this.searchText = null
      this.address.addressLine = suggestion.description
      geoCoder.geocode({
        placeId: suggestion.place_id
      }, (results, status) => {
        if (status === this.google.maps.GeocoderStatus.OK) {
          Util.parseAddress(results, this.address)
          if (this.address.addressLine) {
            this.searchText = this.address.addressLine
          }
          this.address.geolocation = [results[0].geometry.location.lng(), results[0].geometry.location.lat()]
        }
      })
    },

    async gmapInit() {
      this.google = this.$gmapApi
    }
  }
}
</script>
